import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ebs-info',
  templateUrl: './info.page.html',
  styleUrls: ['./info.page.scss'],
})
export class InfoPage implements OnInit {
  constructor() {}

  ngOnInit() {}
}
